// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const workstationSchema = z.object({
  "device_id": z.string().uuid(),
  "jkt": z.string(),
  "assurance": z.string(),
  "enrol_rung": z.number().int(),
  "enrolled_at": z.string().datetime({ offset: true }),
  "key_protection_reported": z.string(),
  "hostname_reported": z.string().optional(),
  "enrolled_by_user_id": z.string().uuid().optional(),
  "status": z.string(),
  "revoked_at": z.string().datetime({ offset: true }).optional(),
  "last_config_fetch_at": z.string().datetime({ offset: true }).optional(),
  "policy_revision": z.number().int(),
  "last_authentication_at": z.string().datetime({ offset: true }).optional(),
  "last_authentication_user_id": z.string().uuid().optional()
});

export const principalLabelSchema = z.object({
  "name": z.string().optional(),
  "deleted": z.boolean().optional()
});

export const workstationsResponseSchema = z.object({
  "workstations": z.array(workstationSchema),
  "principals": z.record(z.string(), principalLabelSchema).optional()
});

export const revokedWorkstationSchema = z.object({
  "device_id": z.string().uuid(),
  "jkt": z.string(),
  "status": z.enum(["revoked"]),
  "revoked_at": z.string().datetime({ offset: true }),
  "changed": z.boolean()
});

export const approveResultSchema = z.object({
  "device_id": z.string().uuid(),
  "jkt": z.string().optional(),
  "hostname_reported": z.string().optional(),
  "outcome": z.string(),
  "prior_assurance": z.string().optional(),
  "changed": z.boolean()
});

export const approvedWorkstationSchema = z.object({
  "device_id": z.string().uuid(),
  "jkt": z.string(),
  "hostname_reported": z.string().nullable(),
  "outcome": z.string(),
  "prior_assurance": z.string(),
  "assurance": z.string(),
  "changed": z.boolean()
});

export const approveWorkstationsSchema = z.object({
  "approved": z.number().int(),
  "counts": z.record(z.string(), z.number().int()),
  "results": z.array(approveResultSchema)
});

export const enrollmentTokenSchema = z.object({
  "id": z.string().uuid(),
  "display_prefix": z.string(),
  "jkt": z.string().optional(),
  "device_cap": z.number().int().min(1).max(1000),
  "redeemed_count": z.number().int().min(0),
  "status": z.string(),
  "created_at": z.string().datetime({ offset: true }),
  "expires_at": z.string().datetime({ offset: true }),
  "redeemed_at": z.string().datetime({ offset: true }).optional(),
  "revoked_at": z.string().datetime({ offset: true }).optional()
});

export const enrollmentTokensResponseSchema = z.object({
  "tokens": z.array(enrollmentTokenSchema)
});

export const mintedTokenSchema = z.object({
  "id": z.string().uuid(),
  "display_prefix": z.string(),
  "jkt": z.string().optional(),
  "device_cap": z.number().int().min(1).max(1000),
  "redeemed_count": z.number().int().min(0),
  "status": z.string(),
  "created_at": z.string().datetime({ offset: true }),
  "expires_at": z.string().datetime({ offset: true }),
  "redeemed_at": z.string().datetime({ offset: true }).optional(),
  "revoked_at": z.string().datetime({ offset: true }).optional(),
  "token": z.string()
});

export const policyRowSchema = z.object({
  "scope": z.string(),
  "scope_ref": z.string().uuid().optional(),
  "patch": z.record(z.string(), z.unknown()),
  "updated_at": z.string().datetime({ offset: true }),
  "updated_by": z.string().uuid()
});

export const seedFieldSchema = z.object({
  "path": z.string(),
  "seedPath": z.string(),
  "kind": z.string(),
  "required": z.boolean().optional(),
  "vocabulary": z.array(z.string()).optional(),
  "tenantVocabulary": z.array(z.string()).optional(),
  "excludedValues": z.array(z.string()).optional(),
  "excludedBecause": z.string().optional(),
  "maxChars": z.number().int().optional(),
  "maxValue": z.number().int().optional(),
  "maxEntries": z.number().int().optional(),
  "tenantNullable": z.boolean().optional()
});

export const seedExclusionSchema = z.object({
  "path": z.string(),
  "seedPath": z.string(),
  "refused": z.boolean(),
  "because": z.string()
});

export const seedSchemaSchema = z.object({
  "$comment": z.string(),
  "seedSchemaVersion": z.number().int(),
  "topLevelKeys": z.array(z.string()),
  "policyPathPrefix": z.string(),
  "fields": z.array(seedFieldSchema),
  "excluded": z.array(seedExclusionSchema)
});

export const policyListResponseSchema = z.object({
  "policies": z.array(policyRowSchema),
  "settable_paths": z.array(z.string()),
  "seed_schema": seedSchemaSchema
});

export const policyDocumentSchema = z.object({
  "exclusiveMode": z.boolean(),
  "environment": z.object({
    "onPremAd": z.boolean(),
    "hybridEntra": z.boolean(),
    "entraOnly": z.boolean(),
    "rdp": z.boolean()
  }),
  "timeouts": z.object({
    "authAttemptSeconds": z.number().int().min(0),
    "brokerCallMs": z.number().int().min(0)
  }),
  "lockdown": z.object({
    "enabled": z.boolean(),
    "message": z.string()
  }),
  "idp": z.object({
    "baseUrl": z.string(),
    "allowedOrigins": z.array(z.string()),
    "proxy": z.string().nullable()
  }),
  "enrollment": z.object({
    "otpChannel": z.string(),
    "atLogonScreen": z.boolean(),
    "deviceSelfEnrolment": z.boolean()
  }),
  "logging": z.object({
    "level": z.string(),
    "fileSink": z.boolean()
  }),
  "userVerification": z.object({
    "method": z.string()
  }),
  "deviceKey": z.object({
    "protection": z.string()
  }),
  "offline": z.object({
    "windowHours": z.number().int().min(0),
    "windowMinutes": z.number().int().min(0)
  }),
  "allowedAuthenticators": z.array(z.string())
});

export const suppressionSchema = z.object({
  "path": z.string(),
  "reason": z.string(),
  "requested_value": z.unknown(),
  "effective_value": z.unknown(),
  "requested_from": z.string()
});

export const policyWarningSchema = z.object({
  "path": z.string(),
  "code": z.string(),
  "detail": z.string()
});

export const effectivePolicySchema = z.object({
  "device_id": z.string().uuid(),
  "assurance": z.string(),
  "policy": policyDocumentSchema,
  "provenance": z.record(z.string(), z.string()),
  "suppressions": z.array(suppressionSchema),
  "warnings": z.array(policyWarningSchema)
});

export const policyImpactSchema = z.object({
  "devices_counted": z.number().int(),
  "devices_with_override": z.number().int(),
  "exclusive_mode_in_force": z.number().int(),
  "shielded": z.array(z.object({
    "device_id": z.string().uuid(),
    "jkt": z.string(),
    "assurance": z.string(),
    "suppressions": z.array(suppressionSchema)
  })),
  "uv_capability_warnings": z.array(z.object({
    "device_id": z.string().uuid(),
    "jkt": z.string(),
    "warnings": z.array(policyWarningSchema)
  })),
  "devices_with_invalid_patch": z.number().int(),
  "truncated": z.boolean()
});

export const policyWriteResultSchema = z.object({
  "scope": z.string(),
  "scope_ref": z.string().uuid().nullable(),
  "fields_changed": z.array(z.string()),
  "policy_revision": z.number().int(),
  "affected_devices": z.number().int()
});

export const workstationEventSchema = z.object({
  "id": z.string().uuid(),
  "device_id": z.string().uuid(),
  "correlation_id": z.string().uuid(),
  "event_code": z.string(),
  "outcome": z.string(),
  "severity": z.number().int().min(1).max(5),
  "occurred_at_claimed": z.string().datetime({ offset: true }),
  "received_at": z.string().datetime({ offset: true }),
  "detail": z.record(z.string(), z.unknown())
});

export const workstationEventsResponseSchema = z.object({
  "events": z.array(workstationEventSchema),
  "evidence": z.enum(["reported_by_workstation"])
});
